const _excluded = ["month"];
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, Filler } from 'chart.js';
import { useQuery } from '@tanstack/react-query';
import { fetchRecommendStats } from '../../../cores/api/api-dashboard';
import { buildRecommendChartData, DEFAULT_MONTHLY_BAR_CHART } from '../../../utils/common-chart';
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, Filler);
const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: true,
            position: 'top'
        },
        tooltip: {
            mode: 'index',
            intersect: false
        }
    },
    scales: {
        x: {
            grid: {
                display: true
            },
            ticks: {
                maxRotation: 45,
                minRotation: 45
            }
        },
        y: {
            beginAtZero: true,
            grid: {
                color: '#e5e7eb'
            }
        }
    }
};
export default function SectionRecommendChart({ params }) {
    const normalizedParams = React.useMemo(() => {
        if (params.mode === 'year') {
            const month = params.month, rest = _objectWithoutProperties(params, _excluded);
            return rest;
        }
        return params;
    }, [params]);
    const _useQuery = useQuery({
        queryKey: ['recommend_stats', normalizedParams],
        queryFn: () => fetchRecommendStats(normalizedParams),
        suspense: true
    }), data = _useQuery.data;
    const chartData = React.useMemo(() => {
        var _a;
        if (!((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length))
            return DEFAULT_MONTHLY_BAR_CHART;
        const dataObj = data.data.reduce((acc, item) => {
            acc[item.key] = {
                ai: item.ai,
                manual: item.manual
            };
            return acc;
        }, {});
        return buildRecommendChartData(dataObj);
    }, [data]);
    return /*#__PURE__*/ React.createElement(Bar, {
        data: chartData,
        options: chartOptions
    });
}
